import { Dialog } from '../../components-v4';
import { css, styled } from '../../components-v4/theme';

export const StyledDialogContent = styled(Dialog.Content)`
  ${({ theme }) => css`
    width: 650px;
    min-height: fit-content;

    ${theme.tokens.media.down('desktop')} {
      width: 100dvw;
      min-height: 100dvh;
    }
  `}
`;

export const StyledDialogPanel = styled(Dialog.Panel)`
  position: relative;
  width: 100%;
  height: 100%;
`;
